import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../config/authConfig";

export default function Login() {
  const { instance } = useMsal();

  const handleLogin = () => {
    instance.loginRedirect(loginRequest).catch(console.error);
  };

  return (
    <div className="login-wrap">
      <div className="login-card">
        <div className="login-logo">📋</div>
        <h1 className="login-title">Incident Report</h1>
        <p className="login-subtitle">
          Sign in with your Insomnia Cookies account to submit an incident report.
        </p>
        <button className="btn-primary" style={{ width: "100%" }} onClick={handleLogin}>
          Sign in with Microsoft
        </button>
      </div>
    </div>
  );
}
